module.exports = __webpack_public_path__ + "img/INSIGHTS (9).65c13c9a.png";